import React from 'react';
import { Handle, Position } from 'reactflow';
import './ActionNode.css';

const ActionNode = ({ data, isConnectable }) => {

    const actionTypes = {
        send_email: { icon: '📧', color: '#667eea' },
        start_email_flow: { icon: '⚡', color: '#8b5cf6' },
        send_webhook: { icon: '🔗', color: '#8b5cf6' },
        delay: { icon: '⏰', color: '#6b7280' },
        schedule: { icon: '📅', color: '#84cc16' }
    };

    const actionInfo = actionTypes[data.actionType] || actionTypes.send_email;

    return (
        <div className="sales-action-node" style={{ '--node-color': actionInfo.color }}>
            <Handle
                type="target"
                position={Position.Left}
                id="action-input"
                isConnectable={isConnectable}
                className="sales-handle sales-handle-input"
            />

            <div className="sales-node-header action">
                <span className="sales-node-icon">{actionInfo.icon}</span>
                <span className="sales-node-title">ACTION</span>
            </div>
            
            <div className="sales-node-content">
                <h4>{data.label}</h4>
                <p className="sales-node-description">
                    {data.actionType === 'send_email' && 'Send automated email to customer'}
                    {data.actionType === 'start_email_flow' && 'Trigger automated email sequence'}
                    {data.actionType === 'send_webhook' && 'Send data to external service'}
                    {data.actionType === 'delay' && 'Wait before next action'}
                    {data.actionType === 'schedule' && 'Schedule action for specific time'}
                </p>
                
                {/* Action-specific configuration preview */}
                <div className="sales-node-config">
                    {data.actionType === 'send_email' && (
                        <span className="sales-config-item">
                            📧 {data.config?.templateName || 'Click to configure'}
                        </span>
                    )}
                    {data.actionType === 'start_email_flow' && (
                        <span className="sales-config-item">
                            ⚡ {data.config?.flowName || 'Click to configure'}
                        </span>
                    )}
                    {data.actionType === 'delay' && (
                        <span className="sales-config-item">
                            ⏰ {data.config?.delayAmount || 1} {data.config?.delayUnit || 'hours'}
                        </span>
                    )}
                    {data.actionType === 'send_webhook' && (
                        <span className="sales-config-item">
                            🔗 {data.config?.webhookUrl ? 'Webhook configured' : 'Click to configure'}
                        </span>
                    )}
                    {data.actionType === 'schedule' && (
                        <span className="sales-config-item">
                            📅 {data.config?.scheduleTime ? 'Schedule set' : 'Click to configure'}
                        </span>
                    )}
                </div>
            
            </div>

            <Handle
                type="source"
                position={Position.Right}
                id="action-output"
                isConnectable={isConnectable}
                className="sales-handle sales-handle-output"
            />
        </div>
    );
};

export default ActionNode;
